import backofficeService from "../../api/backoffice";

export default {
  list(params = {}) { return backofficeService.Api().get("teacher-time-off", { params }).then(response => response.data); },
  create(data) { return backofficeService.Api().post("teacher-time-off", data).then(response => response.data); },
  pdf(id) { return backofficeService.Api().get(`teacher-time-off/${id}/pdf`, { responseType: "blob" }).then(response => response.data); },
};
